import React from "react";
import { Box } from "@mui/material";
import { PageContainer } from "components/shared";
import BreakdownChart from "./BreakdownChart";

const Breakdown = () => {
  return (
    <PageContainer title="Sales Breakdown" subtitle="Breakdown of sales by category">
      <Box height="75vh">
        <BreakdownChart />
      </Box>
    </PageContainer>
  );
};

export default Breakdown;
